import {
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";
import SanctionBanner from "@components/SanctionBanner";
import VaultHeader from "@components/VaultHeader";
import { YieldBridge } from "@components/VaultYield/DepositWithdraw/Tabs";
import useSanction from "@hooks/useSanction";
import useVaultOverview from "@hooks/useVaultOverview";
import AirdropVaultTooltip from "./AirdropVaultTooltip";
import { AIRDROP_VAULT_STRINGS } from "./constants";
import DefiPartnerships from "./Defi/DefiPartnerships";
import Portfolio from "./Portfolio";
import { VaultDeposit, VaultWithdraw } from "./Tabs";
import VaultOverview from "./VaultOverview";

const TABS_DATA = AIRDROP_VAULT_STRINGS.SECTIONS.DEPOSIT_WITHDRAW.TABS;
const BRIDGE_CHAINS = AIRDROP_VAULT_STRINGS.SECTIONS.DEPOSIT_WITHDRAW.BRIDGE;

const Vault = () => {
  const {
    isLoadingAPYData,
    formattedApy,
    formattedTvl,
    isLoadingTotalStaked,
    formattedETHStaked,
  } = useVaultOverview();
  const { isSanctioned } = useSanction();
  return (
    <>
      <Flex direction={"column"} alignItems={"center"} pb="5px">
        <Flex flexDir="column" gap="16px" w="100%" maxW={"736px"}>
          {isSanctioned && <SanctionBanner />}
        </Flex>
      </Flex>
      <Flex
        direction={"column"}
        alignItems={"center"}
        gap="20px"
        p="16px"
        pointerEvents={isSanctioned ? "none" : "auto"}
        opacity={isSanctioned ? 0.5 : 1}
      >
        <VaultHeader
          isLoadingAPYData={isLoadingAPYData}
          isLoadingTotalStaked={isLoadingTotalStaked}
          totalStaked={formattedTvl}
          totalStakedEth={formattedETHStaked}
          apyValue={formattedApy}
          apyLabel={AIRDROP_VAULT_STRINGS.HEADER.STATS.APY}
          totalStakedLabel={AIRDROP_VAULT_STRINGS.HEADER.STATS.TVL}
          title={AIRDROP_VAULT_STRINGS.HEADER.TITLE}
          logo={{
            src: "/assets/agETH.png",
            label: "agETH Logo",
          }}
          tooltipComponent={<AirdropVaultTooltip />}
          auditedUrl="https://kelp.gitbook.io/kelp/kelp-gain/airdrop-gain"
        />
        <Flex flexDir="column" gap="16px" w="100%" maxW={"736px"}>
          <Flex
            flexDir="column"
            pt="4px"
            pb="10px"
            gap="40px"
            borderRadius="24px"
            bg="white"
          >
            <Tabs>
              <TabList fontWeight="600" lineHeight="24px">
                {TABS_DATA.map((data) => (
                  <Tab
                    fontSize={{ base: "12px", xl: "14px" }}
                    key={data.key}
                    py="8px"
                  >
                    {data.title}
                  </Tab>
                ))}
              </TabList>

              <TabPanels>
                <TabPanel p="0">
                  <VaultDeposit />
                </TabPanel>
                <TabPanel p="0">
                  <VaultWithdraw />
                </TabPanel>
                <TabPanel>
                  <YieldBridge
                    chains={BRIDGE_CHAINS.supported}
                    heading={BRIDGE_CHAINS.heading}
                    bridgeURL={"/bridge-wrap-ageth/"}
                  />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Flex>
        </Flex>

        <Portfolio />

        <Flex width="100%" maxW="736px">
          <DefiPartnerships />
        </Flex>

        <VaultOverview />
      </Flex>
    </>
  );
};

export default Vault;
